import React from 'react'
import { PullquoteProps } from './Pullquote'
import { cx } from '@emotion/css'
import {
    StyledPullquote,
    Attribution,
    Icon,
    Chevron,
    StyledLine,
    StyledParagraph,
    StyledFooter,
} from 'component-library/publication/Pullquote/Pullquote.styled'
import { themedValue } from 'component-library/__styling/themed-value'
import { useTheme } from '@emotion/react'

export const WebPullQuote: React.FC<PullquoteProps> = ({ text, attribution }) => {
    const theme = useTheme()
    const classes = cx('pullquote', {
        'pullquote--no-attrib': !attribution,
    })

    const attributionHack = { attribution } as any

    const quote = theme.kind !== 'sevennews' ? text.replace(/[“”]/g, '') : text

    const symbol = themedValue(theme, {
        perthnow: <Icon />,
        sevennews: <Chevron />,
        thewest: <StyledLine />,
    })

    return (
        <StyledPullquote className={classes} {...attributionHack} theme={theme}>
            {symbol}
            <StyledParagraph>{quote}</StyledParagraph>
            {attribution && (
                <StyledFooter>
                    <Attribution className="attribution">{attribution}</Attribution>
                </StyledFooter>
            )}
        </StyledPullquote>
    )
}
